module.exports = __webpack_public_path__ + "img/insta-2.66e9ebec.jpg";